import { render, staticRenderFns } from "./CreateDeposit.vue?vue&type=template&id=8170bae8&scoped=true"
import script from "./CreateDeposit.vue?vue&type=script&lang=js"
export * from "./CreateDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8170bae8",
  null
  
)

export default component.exports